var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicture8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 27,
    height: 27,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAQwSURBVEhLrZZbbFRVFIb/XqDTm20opZ1pSymNvYQGe2HaGcvMVBRUqBp9UEEgGLXGBKugiYIvkogixMQXIVUTjSEaAkXeTEElpSKKaIpNiBIBG5VIbZtCgTJ0zl7+e5+2mZZ2emH+ZGXO2Xvt9c1eZ521D2YkNbgNwWsKV3ovo6/7+uyurr16WIAYMx9ViexA+8+CDesFqx+XsmX1PSFUbhWsmDPkEUVp2MH9guRkbgayEA75Cos6BKvKbIdoSsMONQtSUgxM2zpkBrtR85iZj6rGgaUhTh7CnC9OoSrN+ERN48C0xdPiAr4mXLyYTx8HLU67354mgBmbNUvwyuZenP6lGaJepq+T47ehSLBhq6mWlC1be955oOFtQWoGx2aoMbBCOFQZkpS+DrcCxEsHykSw7EHeTyKR2VCqiL8eWtHQqB4fBVuNTDkH938b4ezJBtM4BMtHgvyKCsLuWamXjS91PY/53gmxfkfoRg8G+vtiL/ceFQQcZn4M7Glk6YCH++C+/wwq9x9A8bXXkBN6HblyCZ4JYLp6VOhJgi5hcEBw4js+7E2C6mqpyCoUC7U/CBzz6bf9VljdEQXvPBMGgXIF3zYL3sMKSztpAT0+WqGbDUxbPzrPC55/TsGRMPIc3EjWsH8EGcWEvRUO24B5hAW+EbizdZjJNThQxyB/4fwf/JN+iyMmUDrirTuRaPGFnRC23sDqvuVuplDmIkm0TyEhwcP1BuRAjGpAVqgNi9VvqJJOuBnQR1h26VjYOht2VOFul4kXUSpYwQB/4+MPBYmJwnNCXoDTsuDTgAtM0auC5TUCr5vRdWfYgS8PEGY34rV2GlsVPDl2wEgStjWh/6qVZvFclm83qjWog6mptJ3CJPJuGEzZsLpjCoFc2yGShAV17qygtMQURCVSNSgYgrfRdhijEZhJo3qK7xlhbfxjebZDJImswY/fC5zZBrYISVy89E9ale0QJmGWRfagmefZUBqfNaUfOM7Sz7edIknkXhxpseBymcVpbDOHUMr6v2+J7RCmYLCM/mfQtIevXIJu63yACzRsymksRFvrSZTfZWDaSpE48B4KNpr5YSmVyYplN2fstWtMFtJ5jrWbluQ7KKhKsh0n09W+LXj0kRFYLC3e5erCvr0fMXgjje2LLVCU4LNPFNLTDaweGRZBfAe923WYqUkkF5s3tSA1dQRorKBAYddOwckTgmNsjy+9qOhjQHlIsM5iid7VhZvwVXNsGjr9U2WcK6eNV6OBthnAsBUiUbWY48PPTlD7JsemL2dRUYk/5o6v9RcTb2+xZMSqJzDXOoVy5tMvLPfdCsuTOTcz9aJq/uco/mA3Fg40wqnPK/UMsq1dWGC1YrH0o1bv6F/uiJ0lkDK0bOYSNPEUDHiuwPN+HzztV+HtZu8jwH+c9sYNBEq41Wl8AQP/A9mvce85EPaWAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img0"
  }), /*#__PURE__*/React.createElement("pattern", {
    width: 27,
    height: 27,
    patternUnits: "userSpaceOnUse",
    id: "pattern1",
    overflow: "hidden",
    patternTransform: "matrix(0.986707 0 0 0.986707 8.32536 8.3252)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.2918 21.6459C43.2918 33.6006 33.6006 43.2918 21.6459 43.2918 9.6912 43.2918 7.26318e-07 33.6006 7.26318e-07 21.6459 7.26318e-07 9.6912 9.6912 7.26318e-07 21.6459 7.26318e-07 33.6006 7.26318e-07 43.2918 9.6912 43.2918 21.6459Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32536 8.3252 34.9665 8.3252 34.9665 34.9663 8.32536 34.9663Z",
    fill: "url(#pattern1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture8);
export default __webpack_public_path__ + "static/media/Picture8.167d3303b83ed43dbb9652fe0e30e06e.svg";
export { ForwardRef as ReactComponent };